import {getAll as getRecords} from "app/requests/admin/posts";
import PaginateTable from "components/helpers/paginate-table";
import Row from "./row";

const Heading = () => (
  <tr>
    <th>Published</th>
    <th>Author</th>
    <th>Episode</th>
    <th>Tags</th>
    <th>Title</th>
    <th>Actions</th>
  </tr>
);

export default function AdminPostsList() {
  const options = {Heading, Row, getRecords};

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-6 text-left mb-1">
              <a className="btn btn-outline-secondary btn-sm" href="/preview/blog/posts">Preview</a>
            </div>
            <div className="col-6 text-right mb-1">
              <a className="btn btn-outline-secondary btn-sm" href="/admin/posts/new">New Post</a>
            </div>
          </div>
          <h1 className="text-center">Posts</h1>
          <PaginateTable {...options} />
        </div>
      </div>
    </div>
  );
}
